export const APP_STARTED = 'APP_STARTED';
export const INITIALIZE_AUTH = 'INITIALIZE_AUTH';
export const INITIALIZE_CONFIG = 'INITIALIZE_CONFIG';
export const QUERY_PARAM_TERM_UPDATED = 'QUERY_PARAM_TERM_UPDATED';
export const PLAN_BUILDER_INITIALIZATION_COMPLETE = 'PLAN_BUILDER_INITIALIZATION_COMPLETE';
export const PLAN_BUILDER_QUANTITY_UPDATED = 'PLAN_BUILDER_QUANTITY_UPDATED';
export const PLAN_BUILDER_SKU_REMOVED = 'PLAN_BUILDER_SKU_REMOVED';
export const PLAN_BUILDER_PRODUCT_LEVEL_FOR_PRODUCT_LINE_UPDATED = 'PLAN_BUILDER_PRODUCT_LEVEL_FOR_PRODUCT_LINE_UPDATED';
export const FETCH_BUNDLES_API_STARTED = 'FETCH_BUNDLES_API_STARTED';
export const FETCH_BUNDLES_API_COMPLETED = 'FETCH_BUNDLES_API_COMPLETED';
export const FETCH_BUNDLES_API_FAILED = 'FETCH_BUNDLES_API_FAILED';
export const FETCH_PER_PRODUCT_PRICING_API_STARTED = 'FETCH_PER_PRODUCT_PRICING_API_STARTED';
export const FETCH_PER_PRODUCT_PRICING_API_COMPLETED = 'FETCH_PER_PRODUCT_PRICING_API_COMPLETED';
export const FETCH_PER_PRODUCT_PRICING_API_FAILED = 'FETCH_PER_PRODUCT_PRICING_API_FAILED';
export const FETCH_PAGED_QUANTITY_PACKS_API_STARTED = 'FETCH_PAGED_QUANTITY_PACKS_API_STARTED';
export const FETCH_PAGED_QUANTITY_PACKS_API_COMPLETED = 'FETCH_PAGED_QUANTITY_PACKS_API_COMPLETED';
export const FETCH_PAGED_QUANTITY_PACKS_API_FAILED = 'FETCH_PAGED_QUANTITY_PACKS_API_FAILED';
export const PLAN_BUILDER_SYNC_CONFIGURATIONS = 'PLAN_BUILDER_SYNC_CONFIGURATIONS';
export const UPDATE_GATES = 'UPDATE_GATES';